import React from "react";
import trampoline from "../../../assets/img/imagefile/imagefile/entire software.png";
import POS from "../../../assets/img/EntranceSoftware/Point-of-Sale (POS).jpg";
import Cloud from "../../../assets/img/EntranceSoftware/Cloud and Local Database.jpg";
import Gates from "../../../assets/img/EntranceSoftware/Electronic Gates.jpg";
import LED from "../../../assets/img/EntranceSoftware/LED Flash light.jpg";
import Mobile from "../../../assets/img/EntranceSoftware/Mobile Application.jpg";
import RFID from "../../../assets/img/EntranceSoftware/RFID Cards Bracelets.jpg";
import SelfService from "../../../assets/img/EntranceSoftware/Self-Service Kiosks.jpg";
import TDisplay from "../../../assets/img/EntranceSoftware/Tracking Display & Tablet.jpg";
import Waiver from "../../../assets/img/EntranceSoftware/Waiver Software.jpg";
import { Link } from "react-router-dom";
import Dashboard from "../../../components/Dashboard";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import plusicon from "../../../assets/img/product_img/plusicon.png";
import Breadcrumb from "../../../Breadcrumb";
import { Helmet } from "react-helmet-async";
import "./ManagementSoftware.css";
import WhatsappButton from "../../../components/WhatsappButton";
const softwareData = [
  {
    title: "Point-of-Sale (POS) Software",
    description: (
      <>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Our advanced POS system now offers:</h2>
        <ul style={{ marginBottom: "20px" }}>
          <li><strong>Flexible Entry Sales:</strong>Manage time-based or cash-based entries with ease.</li>
          <li><strong>Bundle Products:</strong>Offer and manage bundled products to enhance customer value.</li>
          <li><strong>Activity Tracking:</strong> Monitor and record all guest activities within the facility.</li>
          <li><strong>Party/Event Booking:</strong> Efficiently schedule and manage parties or events, integrating seamlessly with your existing operations.</li>
          <li><strong>Comprehensive Customer Registration:</strong> Collect and store detailed customer information, including photo, name, email, address, date of birth, and children's names, ensuring personalized service and effective communication.</li>
        </ul>
        <h2 className="ProductDescription">This system streamlines transactions, reduces wait times, and provides valuable insights into customer preferences.</h2>
      </>
    ),
    image: POS,
  },
  {
    title: "Electronic Gates with Access Readers",
    description:
      (
        <>
          <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Enhance security and operational efficiency with automated entry and exit points:
          </h2>
          <ul style={{ marginBottom: "20px" }}>
            <li><strong>Seamless Access Control:</strong>Automate guest entry and exit, ensuring only authorized access. </li>
            <li><strong>Real-Time Monitoring:</strong>Keep track of guest movements to maintain safety protocols.</li>
          </ul>
          <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>This feature ensures a secure environment while optimizing guest flow.</h2>
        </>
      ),
    image: Gates,
  },
  {
    title: "Self-Service Kiosks",
    description:
      (
        <>
          <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Our advanced POS system now offers:</h2>
          <ul style={{ marginBottom: "20px" }}>
            <li><strong>Flexible Entry Sales:</strong> Manage time-based or cash-based entries with ease.</li>
            <li><strong>Bundle Products:</strong> Offer and manage bundled products to enhance customer value.</li>
            <li><strong>Activity Tracking:</strong> Monitor and record all guest activities within the facility.</li>
            <li><strong>Party/Event Booking:</strong> Efficiently schedule and manage parties or events, integrating seamlessly with your existing operations.</li>
            <li><strong>Comprehensive Customer Registration:</strong> Collect and store detailed customer information, including photo, name, email, address, date of birth, and children's names, ensuring personalized service and effective communication.</li>
          </ul>
          <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>This system streamlines transactions, reduces wait times, and provides valuable insights into customer preferences.</h2>
        </>
      ),
    image: SelfService,
  },
  {
    title: "Waiver Software",
    description: (
      <>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Simplify the registration process with digital waivers:</h2>
        <ul style={{ marginBottom: "20px" }}>
          <li><strong>Efficient Data Collection:</strong> Register customer information swiftly and securely.</li>
          <li><strong>Compliance Management:</strong> Ensure all necessary legal documents are signed and stored electronically.</li>
        </ul>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>This system reduces paperwork and ensures all records are easily accessible.</h2>
      </>
    ),
    image: Waiver,

  },
  {
    title: "Tracking Display",
    description: (
      <>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Keep parents and staff informed with real-time activity tracking:</h2>
        <ul style={{ marginBottom: "20px" }}>
          <li><strong>Activity Monitoring:</strong> Display ongoing activities and participant locations.</li>
          <li><strong>Enhanced Safety:</strong>  Quickly locate and monitor children within the facility.</li>
        </ul>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>This feature provides peace of mind to parents and ensures staff can efficiently manage the play area.</h2>
      </>
    ),
    image: TDisplay,
  },
  {
    title: "RFID Cards/Bracelets",
    description: (
      <>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Offer guests a convenient and secure access method:</h2>
        <ul style={{ marginBottom: "20px" }}>
          <li><strong>Easy Access:</strong> Guests can enter restricted areas or access services with a simple tap.</li>
          <li><strong>Cashless Transactions:</strong> Facilitate purchases within the facility without the need for cash.</li>
        </ul>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>RFID technology enhances the guest experience by providing convenience and security.</h2>
      </>
    ),
    image: RFID,
  },
  {
    title: "LED Flash Bands",
    description: (
      <>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Innovative LED bracelets to manage playtime:</h2>
        <ul style={{ marginBottom: "20px" }}>
          <li><strong>Time Management :</strong> Use different colored lights to indicate session times.</li>
          <li><strong>Activity Tracking :</strong> Monitor how long each child has been engaged in specific activities.</li>
        </ul>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>These bands add a fun element for kids while assisting staff in managing play durations effectively.</h2>
      </>
    ),
    image: LED,
  },
  {
    title: "Mobile Application for Live Reporting",
    description: (
      <>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Stay connected with real-time insights through our mobile app: </h2>
        <ul style={{ marginBottom: "20px" }}>
          <li><strong>Live Reports :</strong> Access up-to-date sales data, booking schedules, and operational metrics from anywhere, enabling informed decision-making on the go.</li>
        </ul>
      </>
    ),
    image: Mobile,
  },
  {
    title: "Cloud and Local Database Options",
    description: (
      <>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Choose the data management solution that best fits your needs:</h2>
        <ul style={{ marginBottom: "20px" }}>
          <li><strong>Cloud-Based Database :</strong> Benefit from remote access, automatic updates, and data backup, ensuring your information is secure and accessible.</li>
          <li><strong>Local Database :</strong> Maintain data on-site for enhanced control and offline access, ideal for locations with limited internet connectivity.</li>
        </ul>
        <h2 className="ProductDescription" style={{ marginBottom: "20px" }}>Our Playground Management Software is designed to create a safe, efficient, and enjoyable environment for all. By integrating these features, you can focus on delivering exceptional experiences, knowing that your operations are optimized and secure.</h2>
      </>
    ),
    image: Cloud,
  },

];

const ManagementSoftware = () => {
  const description = (
    <>
       <h2 className="ProductDescription">
        We at Global Entertainment Manufacturer design high-quality Performance Trampolines for trampoline parks. As a leading Trampoline Park Manufacturer in Jordan, we build our trampolines with premium materials to ensure greater height, improved airtime, and ultimate control.
      </h2>
    </>
  );

  return (
    <div>
      {/* SEO Meta Tags */}
      <Helmet>
        <meta
          name="playgrounds"
          content="Experience the ultimate fun with GEM, the highest quality trampoline for your indoor playground. Perfect for endless entertainment and active play indoors."
        />
      </Helmet>

      <Header />

      {/* Breadcrumb Section */}
      <Dashboard
        Breadcrumb={
          <div className="breadcrumb-container">
            <Breadcrumb />
          </div>
        }
        title="Entrance Software"
        imageUrl={trampoline}
        description={description}
      />

      {/* Quotation Button */}
      <div >
        <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
        <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div className="icon-container">
            <img
              src={plusicon}
              alt="trampoline park with soft play"
              className="Producticon"
              style={{ cursor: "pointer" }}
            />
            <button className="quotation-button">Get Quotation</button>
          </div>
        </Link>
      </div>

      {/* Software Features Section */}
      <div className="software-container">
        {/* <h2 className="software-title">Our Software Solutions</h2> */}

        {softwareData.map((software, index) => (
          <div
            key={index}
            className={`software-row ${index % 2 === 1 ? "reverse-row" : ""}`}
          >
            {/* Left Side - Image */}
            <div className="software-column image-column order-2">
              <img
                src={software.image}
                alt={software.title}
                className="software-image"
              />
            </div>

            {/* Right Side - Content */}
            <div className="software-column content-column order-2">
              <div className="software-content">
                <h3 className="software-heading">{software.title}</h3>
                <div className="software-description">{software.description}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default ManagementSoftware;
